<template>
  <div class="yunxiao parent reserve-list full-page">
    <div class="header flex-between" v-if="choosedStudent">
      <div class="header-l" @click="changeStudent" v-show="studentList.length > 0">
        <div class="student-photo">{{ choosedStudent.name.slice(-2) }}</div>
        <div class="van-ellipsis">{{ choosedStudent.name }}</div>
        <van-icon
          class="xiala"
          class-prefix="vxs-icon"
          name="system_choose"
          size="10"
          color="var(--g6)"
        />
      </div>
      <span class="header-r" @click="goReserveLog"
        ><van-icon class="icon" name="todo-list" />约课记录</span
      >
    </div>
    <schedule-calendar
      :eventDays="eventDays"
      :defaultDate="defaultDate"
      @chooseDate="v => (this.choosedDate = v)"
      @monthChange="monthChangeHandler"
    />
    <div class="event-container">
      <van-loading type="spinner" v-if="courseLoading" size="calc(var(--w) * 16)">
        加载中...
      </van-loading>
      <div class="card-wrap">
        <p class="date-title" v-if="courseData.courseQuantity">
          {{ dateStr }}
          <template v-if="courseData.courseQuantity">
            （{{ courseData.courseQuantity }}节课）
          </template>
        </p>
        <template v-if="courseData.courseArrangeRecordVos">
          <div
            class="card"
            v-for="(item, idx) of courseData.courseArrangeRecordVos"
            :key="item.id + '' + idx"
          >
            <div class="card-top">
              <div>
                <div class="l1" v-if="item.courseArrangePlanType === 0">{{ item.className }}</div>
                <div class="l1" v-else>{{ item.curriculumName }}</div>
                <div class="l2">
                  <span>{{ item.courseArrangeStartTime | formatDatetime('MM月dd日') }}</span>
                  <span>（{{ app.base.weekDays[item.courseArrangeWeekday] }}）</span>
                  <span
                    >{{ item.courseArrangeStartTime | formatDatetime('hh:mm') }}～{{
                      item.courseArrangeEndTime | formatDatetime('hh:mm')
                    }}
                  </span>
                </div>
                <div
                  class="l2"
                  v-if="getTeacher(item.teacherList) || item.campusName || item.classRoomName"
                >
                  {{
                    [getTeacher(item.teacherList), item.campusName, item.classRoomName]
                      .filter(v => v)
                      .join('·')
                  }}
                </div>
              </div>
              <div class="card-top-r">
                <div class="btn c3" v-if="item.courseReserveStatus == 0">未开始</div>
                <div
                  class="btn c1"
                  v-if="
                    item.courseReserveStatus == 1 && !item.hasReserved && item.remainStudentNum > 0
                  "
                  @click="addReserve(item)"
                >
                  立即预约
                </div>
                <div class="btn c2" v-if="item.hasReserved" @click="$router.push('/reserveLog')">
                  已预约
                </div>
                <div
                  class="btn"
                  v-if="
                    item.courseReserveStatus == 1 && !item.hasReserved && item.remainStudentNum <= 0
                  "
                >
                  约满
                </div>
                <div class="btn" v-if="item.courseReserveStatus == 2 && !item.hasReserved">
                  已截止
                </div>
              </div>
            </div>
            <div class="content-container" v-if="item.courseArrangeContent">
              <div class="title-1">上课内容：</div>
              <div class="content" :class="{ 'van-ellipsis': !item.fold1 }">
                {{ item.courseArrangeContent }}
              </div>
              <div
                class="flod"
                :class="{ display: item.fold1 }"
                @click.stop="$set(item, 'fold1', !item.fold1)"
              >
                <van-icon name="arrow-down" size="var(--fs-lg)" />
              </div>
            </div>
            <div v-if="item.remark" class="colum">
              <div class="icon-line">
                <van-icon class-prefix="vxs-icon" name="pushpin-line" />
              </div>
              <div class="remark-content" :class="{ 'van-ellipsis': !item.fold }">
                {{ item.remark }}
              </div>
              <div
                class="flod"
                :class="{ display: item.fold }"
                @click.stop="$set(item, 'fold', !item.fold)"
              >
                <van-icon name="arrow-down" size="var(--fs-lg)" />
              </div>
            </div>
            <div class="card-bottom van-hairline--top flex-between">

              <template v-if="item.hasReserved && item.exceedLastCancelTime == 1">
                <div></div>
                <div>{{ item.lastCancelTime | formatDatetime("yyyy-MM-dd hh:mm") }}前可取消约课</div>
                <div></div>
              </template>
              <template v-else>
                <div v-if="item.courseReserveStatus == 0">
                  预约开始时间：{{ item.startTime | formatDatetime('yyyy-MM-dd hh:mm') }}
                </div>
                <div v-else>
                  预约截止时间：{{ item.endTime | formatDatetime('yyyy-MM-dd hh:mm') }}
                </div>
                <div v-if="item.showRemainNumber">剩余名额：{{ item.remainStudentNum }}</div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        v-if="courseData.courseArrangeRecordVos.length === 0 && !courseLoading"
        description="没有可预约课程～"
        style="text-align: center"
        image-size="128"
      >
      </van-empty>
    </div>
    <van-popup
      :value="studentPickerShow"
      position="bottom"
      @click-overlay="studentPickerShow = false"
    >
      <van-picker
        :show-toolbar="true"
        title="切换学员"
        :value-key="'name'"
        :columns="studentList"
        @confirm="studentPickerConfirm"
        :default-index="defaultIndex"
        @cancel="studentPickerShow = false"
      />
    </van-popup>
    <reserveDialog
      v-model="reserveErrDialogShow"
      :reserveErrData="reserveErrData"
      :resCourse="resCourse"
    />
    <van-dialog v-model="conflictShow" title="提示" confirm-button-text="我知道了">
      <div class="wrapper">
        <div>检测到您在同时段已有其他上课安排，请预约其他课程</div>
        <div v-for="item in conflictList" :key="item.id">
          <div class="line-1 top">
            时间：<span>{{ item.startTime | formatDatetime('MM月dd日') }}</span
            >(<span>{{ item.startTime | getWeek() }}</span
            >){{ item.startTime | formatDatetime('hh:mm') }}～{{
              item.endTime | formatDatetime('hh:mm')
            }}
          </div>
          <div class="line-1" v-if="item.coursePlanType == 0">班级：{{ item.className }}</div>
          <div class="line-1" v-else>课程：{{ item.curriculumName }}</div>
          <div class="line-1">老师：{{ item.teacher }}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import scheduleCalendar from '@x3/vue/comp/schedule-calendar.vue';
import reserveDialog from '@parent/components/reserve-dialog.vue';

export default {
  name: 'reserveList',

  data() {
    let strDate = this.$route.query.date,
      date;

    if (strDate) {
      date = new Date(strDate.replace(/-/g, '/'));
    } else {
      date = new Date();
    }

    return {
      pageTitle: '约课记录',
      // 默认日历显示日期
      defaultDate: date,
      // 选中天
      choosedDate: date,
      // 选中月
      currentMonth: app.tool.date.formatDatetime(date, 'yyyy-MM'),
      // 标点显示的日期数据
      eventDays: [],
      courseData: {
        date: '',
        courseQuantity: '',
        courseArrangeRecordVos: [],
      },
      studentList: [],
      courseLoading: false,
      studentPickerShow: false,
      choosedStudent: null,
      resCourse: '',
      reserveErrDialogShow: false,
      reserveErrData: '',

      conflictList: [],
      conflictShow: false,
    };
  },
  computed: {
    defaultIndex() {
      if (!this.choosedStudent || !this.studentList.length) return '';
      let idx = this.studentList.findIndex(v => v.id === this.choosedStudent.id);
      return idx;
    },
    dateStr() {
      let infos = this.courseData;
      if (!infos.date && !new Date(infos.date)) return '--';
      let infosDate = infos.date;
      let currentDateStr = app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd');
      let infosDateStr = app.tool.date.formatDatetime(new Date(infosDate), 'yyyy-MM-dd');
      let dayStr = app.base.weekMap[new Date(infos.date).getDay()];
      if (currentDateStr === infosDateStr) {
        return '今日/' + dayStr + ' ';
      }
      return (
        app.tool.date.formatDatetime(new Date(infosDate), 'yyyy年MM月dd日') + '/' + dayStr + ' '
      );
    },
  },
  methods: {
    // 按月获取本月数据
    async getMonthData(sid) {
      let res = await this.$api.getReserveDate({
        monthDate: this.currentMonth,
        studentId: this.choosedStudent.id || '',
      });
      if (res.code === 200) {
        this.eventDays = res.data;
      }
    },
    // 按天获取数据
    async getDayData() {
      this.courseLoading = true;
      try {
        if (this._cp) {
          try {
            this._cp.cancel();
          } catch (err) {
            console.log('取消上次计算了');
          }
        }
        this._cp = this.$api.studentReserveList({
          date: app.tool.date.formatDatetime(this.choosedDate, 'yyyy-MM-dd'),
          studentId: this.choosedStudent.id || '',
        });
        let res = await this._cp;
        if (res.code === 200) {
          this.courseData = {
            date: res.data && res.data[0] && res.data[0].courseArrangeStartTime,
            courseQuantity: res.data.length,
            courseArrangeRecordVos: res.data || [],
          };
        }
        this.courseLoading = false;
        return res;
      } catch (err) {
        this.courseLoading = false;
        return Promise.reject(err);
      }
    },
    // 切换月
    monthChangeHandler(val) {
      this.currentMonth = val;
    },
    addReserve(resCourse) {
      //立即预约
      let {
        curriculumName,
        priceItemName,
        courseArrangeStartTime,
        courseArrangeWeekday,
        courseArrangeEndTime,
        courseArrangePlanType,
        className,
      } = resCourse;
      let timeStr = app.tool.date.formatDatetime(courseArrangeStartTime, 'MM月dd日') + ' ';
      timeStr += `（${app.base.weekDays[courseArrangeWeekday]}） `;
      timeStr += app.tool.date.formatDatetime(courseArrangeStartTime, 'hh:mm');
      timeStr += '~';
      timeStr += app.tool.date.formatDatetime(courseArrangeEndTime, 'hh:mm');

      let classNameStr = courseArrangePlanType === 0 ? className : `${curriculumName}`;
      vant.Dialog.confirm({
        title: '约课确认',
        message: `是否确认预约${classNameStr}，${timeStr} ?`,
      })
        .then(() => {
          this.showLoading();
          this.$api
            .studentReserve({
              campusId: resCourse.campusId,
              classId: resCourse.classId,
              courseArrangeId: resCourse.courseArrangeId,
              courseReserveId: resCourse.id,
              priceItemId: resCourse.priceItemId,
              studentId: this.choosedStudent.id,
              curriculumId: resCourse.curriculumId,
            })
            .then(res => {
              this.$toast.clear();
              if (res.code == 200) {
                vant.Dialog.alert({
                  title: '约课成功',
                  message: '约课成功，请注意核实上课时间，做好上课准备',
                  confirmButtonText: '确定',
                });
                this.getDayData();
              } else if (res.code == 830000018) {
                //学员剩余课时少于约课所需课时

                this.resCourse = resCourse;
                this.reserveErrDialogShow = true;
                this.reserveErrData = res.data;
                // vant.Dialog.alert({
                //   title: "课时不足",
                //   message: `<div class="reserve_d1">学员的 “${resCourse.curriculumName}” 课时不足，请购买后再预约</div><div class="reserve_d2">剩余可用课时：${res.data.totalRemainAmount}</div><div class="reserve_d2">本次约课所需课时：${res.data.courseAmount}</div>`,
                //   confirmButtonText: "确定",
                // })
              } else if (res.code == 830000032) {
                this.conflictList =
                  res.data &&
                  res.data.courseArrangeList &&
                  res.data.courseArrangeList.map(item => {
                    return {
                      id: item.id,
                      teacher:
                        item.courseArrangeTeacherVoList &&
                        item.courseArrangeTeacherVoList.find(t => t.teacherRule == 0) &&
                        item.courseArrangeTeacherVoList.find(t => t.teacherRule == 0).teacherName,
                      coursePlanType: item.coursePlanType,
                      curriculumName: item.curriculumName,
                      className: item.className,
                      startTime: item.startTime,
                      endTime: item.endTime,
                    };
                  });
                this.conflictShow = true;
              } else if (res.code == 830000037) {
                const unit = {1: '每月', 2: '每周' , 3: '每天'}[res.data.companyRule.reserveTimePeriod]
                vant.Dialog.alert({
                  title: '提示',
                  message: `机构设置“${unit}最多可约课${res.data.companyRule.reserveMaxTimes}次”，学员 ${this.choosedStudent.name} 已约课${res.data.studentReserveRecordCount}次，不能继续预约。可取消部分约课后再约，或者联系机构老师处理。`,
                  confirmButtonText: '我知道了',
                });
              } else {
                this.$toast.fail(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    goReserveLog() {
      //约课记录
      this.$router.push(`/reserveLog`);
    },
    changeStudent() {
      //切换学员
      this.studentPickerShow = true;
    },
    studentPickerConfirm(e) {
      this.studentPickerShow = false;
      this.choosedStudent = e;
      Promise.all([this.getMonthData(), this.getDayData()]);
    },
    getTeacher(teachers) {
      let tcs = teachers.filter(v => v.teacherRule === 0).map(v => v.teacherName);
      if (tcs.length) {
        return tcs.join('、');
      } else {
        return '';
      }
    },
  },
  created() {
    this.showLoading();
    this.$api.parentGetStudentList().then(res => {
      this.$toast.clear();
      this.studentList = res.data;
      if (res.data.length > 0) {
        this.choosedStudent = res.data[0];
        Promise.all([this.getMonthData(), this.getDayData()]);
      }
    });
  },
  watch: {
    currentMonth(nv, ov) {
      this.getMonthData();
    },
    choosedDate(nv, ov) {
      this.getDayData();
    },
  },
  components: {
    scheduleCalendar,
    reserveDialog,
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.parent.reserve-list {
  display: flex;
  flex-direction: column;
  .header {
    display: flex;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    background-color: var(--white);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    justify-content: space-between;
    .header-l {
      display: flex;
      align-items: center;
      max-width: calc(100% - var(--w) * 80);

      .student-photo {
        margin-right: calc(var(--gap) * 8);
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
        background-color: #ff8534;
        color: var(--white);
        text-align: center;
        font-size: var(--fs-xs);
        flex-shrink: 0;
      }
      .van-ellipsis {
        max-width: 100%;
      }
    }
    .header-r {
      color: var(--g7);
      flex-shrink: 0;
      white-space: nowrap;
      width: calc(var(--w) * 80);
      text-align: right;
      .icon {
        margin-right: calc(var(--gap) * 2);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        vertical-align: middle;
        color: var(--g7);
      }
    }
  }
  .date-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: calc(var(--gap) * 8) 0;
    padding: 0 calc(var(--gap) * 16);
    box-sizing: border-box;
    height: calc(var(--w) * 26);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    color: var(--g6);
  }
  .event-container {
    flex: 1;
    overflow-y: auto;
    ::v-deep .van-loading {
      margin-top: calc(var(--gap) * 16);
      text-align: center;
    }
    .card-wrap {
      padding: 0 calc(var(--gap) * 16);
      .card {
        margin-bottom: calc(var(--gap) * 12);
        background-color: var(--white);
        border-radius: var(--radius-sm);
        .card-top {
          position: relative;
          padding: calc(var(--gap) * 12) calc(var(--gap) * 100) calc(var(--gap) * 12)
            calc(var(--gap) * 16);
          .l1 {
            font-size: var(--fs-ex1);
            line-height: var(--lh-ex1);
            font-weight: var(--bold);
            color: var(--g8);
          }
          .l2 {
            margin-top: calc(var(--gap) * 8);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            color: var(--g6);
          }
          .card-top-r {
            position: absolute;
            top: 0;
            right: calc(var(--gap) * 16);
            bottom: 0;
            display: flex;
            align-items: center;
            .btn {
              width: calc(var(--gap) * 72);
              border-radius: var(--radius-md);
              text-align: center;
              padding: calc(var(--gap) * 6);
              font-size: var(--fs-md);
              font-weight: var(--bold);
              line-height: var(--lh-md);
              background-color: var(--g1);
              color: var(--g5);
              &.c1 {
                background-color: var(--c1);
                color: var(--white);
              }
              &.c2 {
                color: var(--c2);
              }
              &.c3 {
                color: var(--c4);
              }
            }
          }
        }
        .content-container {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          color: var(--g6);
          padding: 0 calc(var(--gap) * 16);
          .title-1 {
            flex: 0 0 auto;
          }
          .content {
            font-size: var(--fs-md);
            line-height: var(--lh-sm);
            flex: 1 1 auto;
            text-align: left;
            padding-right: 6px;
          }
          .flod {
            height: var(--fs-lg);
            width: var(--fs-lg);
            > i {
              transition: all 0.3s;
            }
            &.display > i {
              transform: rotateZ(180deg);
            }
          }
        }
        .colum {
          position: relative;
          margin: calc(var(--gap) * 8) calc(var(--gap) * 16);
          padding: 0 calc(var(--gap) * 24);
          height: auto;
          color: var(--g6);
          .icon-line {
            left: 0;
            position: absolute;
            height: var(--fs-lg);
            width: var(--fs-lg);
          }
          .remark-content {
            font-size: var(--fs-md);
            line-height: var(--lh-sm);
          }
          .flod {
            position: absolute;
            right: 0;
            height: var(--fs-lg);
            width: var(--fs-lg);
            bottom: calc(var(--gap) * 2);
            > i {
              transition: all 0.3s;
            }
            &.display > i {
              transform: rotateZ(180deg);
            }
          }
        }
        .card-bottom {
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
          padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        }
      }
    }
  }

  .wrapper {
    padding: 16px;
    max-height: 400px;
    overflow-y: auto;
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g7);
    .line-1.top {
      margin-top: 12px;
    }
  }
}
</style>
